import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.dispatch("start", { prefix: "massimo-thinking", target: window });
  }

  disconnect() {
    // Dispatch on window: by the time disconnect fires, this.element is detached
    // and events dispatched on it don't bubble to ancestors anymore.
    this.dispatch("end", { prefix: "massimo-thinking", target: window });
  }
}
